let inject = [
  '$scope',
  'specificActListService',
  '$state',
  '$rootScope',
  '$timeout',
  'SessionService'
];

class SpecificActListController {
  constructor($scope, specificActListService, $state, $rootScope, $timeout, SessionService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
	this.SessionService = SessionService;
    this.specificActListService = specificActListService;
    this.activities = [];
	
	this.search = {};

  }

  $onInit() {
	this.shCtrl.activate();
	this.order = 'date_entered';
	this.desc = true;
	this.userId = this.shCtrl.globals.currentUser.userId;
    this.filter = {};
	this.cacheFilter = {
		firtsConsulta : true
	};
	
	this.currentPageCache = 0;
	
	this.currentPage = 1;
    this.getActivities();
	
	this.totalItems = 0;
	this.totalPages = 1;
	
	this.exportLoading = false;
	
	this.ultimaActualizacion = '';

  }
  
  orderBy(name) {
	  if(this.order == name) {
		  this.desc = !this.desc;
	  }else {
		  this.order = name;
		  this.desc = true;
	  }
	  
	  this.getActivities(true);
  }

  getActivities(ordenar=false) {
	if((!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache) || ordenar) {
		this.currentPageCache = angular.copy(this.currentPage);
		this.cacheFilter = angular.copy(this.filter);
		
		this.loading = true;
		this.error = false;
		this.errorMsg = '';
		
		this.data = {
					'userId' : this.userId,
					'pageNumber' : (this.currentPage) ? this.currentPage : 1,
					'pageSize' : 20,
					'filter' : this.filter,
					'consulta' : 'actividades',
					'order'		: this.order,
					'desc'		: this.desc
					};
					
		this.specificActListService.getActivitiesData(this.data).then(response => {
			this.loading = false;
			
			if(response.error) {
				this.error = true;
				this.errorMsg = response.mensaje;
			}else {
				
				this.activities = response.actividades;
				this.totalItems = response.totalItems;
				this.totalPages = response.totalPage;
				this.ultimaActualizacion = response.ultimaActualizacion;
			}
			if((this.error || !this.activities.length) && this.errorMsg == '') {
					this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
			}
		}).catch(reason => {
			
			console.log(reason);
			  this.loading = false;
			  this.error = true;
				if(this.error && this.errorMsg == '') {
					this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
				}
		});
	}
  }
  
  exportarXls() {
	  this.exportLoading = true;
	  
	  let action = 'listado';
	  if(this.search.id) {
		  action = 'detalle';
	  }
	  let data = {
		  'pageNumber' : 1,
		  'pageSize' : this.totalItems,
		  'userId' : this.userId,
		  'consulta' : 'actividades',
		  'filter' : this.filter,
		  'accion' : action,
		  'order'		: this.order,
		  'desc'		: this.desc
	  };
	  if(this.search.id) {
		  data['id'] = this.search.id;
	  }
	  this.specificActListService.exportarXls(data).then(response => {
		
		this.exportLoading = false;
        let ruta = response.split('/');
		
		
		var link = document.getElementById("labelprueba");
        link.setAttribute("href", response);
        link.setAttribute("download", ruta[ruta.length - 1]);
        link.click();
    }).catch(reason => {
		$this.exportLoading = false;
	});
  }
  
  salirDetalle() {
	  this.search = {};
  }

}

SpecificActListController.$inject = inject;

export default SpecificActListController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/specific-act-list/specific-act-list.controller.js
 **/